export const fetchPlayerProfile = async (playerId) => {
  const [infoRes, statsRes] = await Promise.all([
    fetch(`https://statsapi.mlb.com/api/v1/people/${playerId}?hydrate=currentTeam,education,draft`),
    fetch(`https://statsapi.mlb.com/api/v1/people/${playerId}/stats?stats=career&group=hitting,pitching`)
  ]);

  if (!infoRes.ok) throw new Error('Failed to fetch player info');

  const infoData = await infoRes.json();
  const statsData = statsRes.ok ? await statsRes.json() : { stats: [] };

  const player = infoData.people?.[0] || null;

  const hitting = statsData.stats?.find(s => s.group?.displayName === 'hitting')?.splits?.[0]?.stat || null;
  const pitching = statsData.stats?.find(s => s.group?.displayName === 'pitching')?.splits?.[0]?.stat || null;

  return { player, hitting, pitching };
};